import { createApp } from "vue";
import App from "./App.vue";

const config = window.advancedCookieDialogue
  ? window.advancedCookieDialogue
  : {};

createApp(App, config).mount("#advanced-cookie-dialogue");

const advancedCookieBannerdocumentTriggers = document.querySelectorAll(
  "[data-open-advanced-cookie-dialogue], [href$='#open-advanced-cookie-dialogue']"
);

const onTrigged = event => {
  event.preventDefault();
  let content = null;
  const cookie = document.cookie
    .split("; ")
    .find(item => item.startsWith("ppfinans-cookie-settings"));

  if (cookie) {
    content = cookie.split("=")[1];
    const contentObject = JSON.parse(content);
    contentObject.isUpdated = false;
    const contentString = JSON.stringify(contentObject);
    document.cookie =
      "ppfinans-cookie-settings=" + contentString + ";Secure;path=/";
  }
  window.location.reload();
};

if (advancedCookieBannerdocumentTriggers.length) {
  advancedCookieBannerdocumentTriggers.forEach(item => {
    item.addEventListener("click", onTrigged);
  });
}
